<template>
    <form-content
        v-if="!form.loggedInOnly || (form.loggedInOnly && loggedUser)"
        :id="value"
        class="content form_content"
        @send="onSend"
    />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import FormContent from '@/components/forms';

export default {
    components: {
        FormContent
    },

    props: {
        value: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            form: {}
        };
    },

    computed: {
        ...mapGetters(['loggedUser'])
    },

    async created() {
        try {
            this.form = await this.getForm(this.value);
        } catch (err) {
            console.error(err);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            getForm: 'forms/show'
        }),

        onSend() {
            this.$toasted.success(this.$t('form.formSentSuccessfully'));
        }
    }
};
</script>
